import { IconName } from '@optimus-web/icons';
import { ActionType, RouteName } from '@mews-commander/enums';
import { useResolveRoute } from '@mews/routing';
import { LocalizedProperty, lt } from '@mews/framework';
import { BookableService } from '@mews-commander/legacy-entities/src/ducks/servicesNew';
import { isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { useCommanderSelector } from '@mews-commander/utils';
import { HeadingAction } from '../../../legacy/React/Components/HeadingAction/Action/types';

export const useHeadingActions = (services: BookableService[] | undefined): HeadingAction[] => {
    const resolveRoute = useResolveRoute();
    const isBlockCreationEnabled = useCommanderSelector(isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled);

    if (!services || !isBlockCreationEnabled) return [];

    return [
        {
            icon: IconName.PlusSimple,
            items: services.map((service) => ({
                icon: IconName.PlusSimple,
                text: <LocalizedProperty property={service.names} />,
                type: ActionType.Link,
                url: resolveRoute(RouteName.AvailabilityBlockCreate, {
                    query: { OwnerId: service.id },
                }),
            })),
            text: lt('Create'),
            type: ActionType.Dropdown,
        },
    ];
};
